import styled from 'react-emotion';
import { themeGet } from 'styled-system';
import { Heading, Text, FlexRow } from '../misc';

const Item = styled(FlexRow)`
  width: 100%;
  padding: ${themeGet('space.4')}px 0;
  align-items: stretch;
`;

const ItemImage = styled('div')`
  background-image: url(${props => props.src});
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  border-radius: 4px;
  margin-right: ${themeGet('space.4')}px;
  flex: 0 0 80px;

  @media screen and (min-width: 40em) {
    margin-right: ${themeGet('space.3')}px;
  }

  @media screen and (min-width: 52em) {
    margin-right: ${themeGet('space.4')}px;
  }
`;

const ItemPrice = styled(FlexRow)`
  justify-content: flex-end;
  flex: auto;

  span {
    white-space: nowrap;
  }
`;

Item.Image = ItemImage;
Item.Price = ItemPrice;

const Summary = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%
  opacity: ${props => (props.open ? 1 : 0)};
  pointer-events: ${props => (props.open ? 'auto' : 'none')};
  transform: translate(0px, ${props => (props.open ? '0px' : '40px')});
  transition: transform 0.5s ease, opacity 0.5s ease;
  background-color: white;
  padding: ${themeGet('space.3')}px;
  z-index: 3;

  @media screen and (min-width: 52em) {
    transform: none;
    width: 100%;
    height: calc(100% - 65px);
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    opacity: 1;
  }
`;

const ItemWrapper = styled('div')`
  width: 100%;
  overflow-y: scroll;
  -ms-overflow-style: none;
  padding: ${themeGet('space.3')}px;
`;

const PriceRow = styled(FlexRow)`
  width: 100%;
  justify-content: space-between;

  &:not(:last-child) {
    margin-bottom: ${themeGet('space.2')}px;
  }
`;

const Subtotal = styled(Text)`
  font-size: 18px;
  font-weight: 300;
  color: ${themeGet('colors.greyDarkest')};
`;

const SummaryPrice = styled(Text)`
  color: ${themeGet('colors.blueDarker')};
  font-weight: 400;
  white-space: nowrap;
  font-size: 18px;
`;

const PriceContainer = styled('div')`
  padding: ${themeGet('space.3')}px;
  width: 100%;
  border-bottom: ${props =>
    props.withBorder ? '2px solid rgba(218,225,231,1)' : '0'};
  border-top: ${props =>
    props.withBorder ? '2px solid rgba(218,225,231,1)' : '0'};
`;

const Total = styled(Subtotal)`
  font-size: 20px;
  font-weight: 500;
`;

Summary.Items = ItemWrapper;
Summary.PriceContainer = PriceContainer;
Summary.PriceRow = PriceRow;
Summary.Price = SummaryPrice;
Summary.Tax = Summary.Subtotal = Subtotal;
Summary.Total = Total;

// @padding
export const SummaryTotal = styled(Heading)`
  font-size: 20px;
  color: ${themeGet('colors.black')};
  padding: ${themeGet('space.3')}px;
`;

export const SummaryTotalPrice = styled(SummaryTotal)`
  color: ${themeGet('colors.blueDarker')};
`;

// @width
// @padding
// @border
// @overflow

// @padding
export const SummaryTax = styled('span')`
  font-size: 16px;
  padding: 0 ${themeGet('space.4')}px;
  color: ${themeGet('colors.blueDarker')};
`;

// @flex

export { Item, Summary };



// WEBPACK FOOTER //
// ../shop_main/components/summary/style.js